// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiFlowNodeCategorySchema = z.enum(['AGENT','SUB_AGENT','TOOL_FUNCTION','TOOL_HOSTED','TOOL_MCP','SKILL','MIDDLEWARE','GUARDRAIL','MEMORY','STATE','HOOK','ROUTER','ENTRY','EXIT'] as const);

export type AiFlowNodeCategoryType = `${z.infer<typeof AiFlowNodeCategorySchema>}`

export default AiFlowNodeCategorySchema;
